import axios from "@/axios";

export const namespaced = true

const defaultData = {
    orderId: 0,
    
    partnerCost: 0,
    partnerTransactionCost: 0,
    partnerOtherCost: 0,
    PartnerNotToExceed: 0,
    PartnerTotalClaimed: 0,
    
    UsCost: 0,
    UsTransactionCost: 0,
    UsOtherCost: 0,
    UsNotToExceed: 0,
    UsTotalClaimed: 0,
}
export const state = {
    costSummary: Object.assign({}, defaultData),
}

export const getters = {
    costSummary: state => state.costSummary,
}
    
export const mutations = {
    SET_COST_SUMMARY: (state, response) => state.costSummary = Object.assign({}, defaultData, response.data),
    CLEAR_DATA: (state) => state.costSummary = Object.assign({}, defaultData),
}

export const actions = {
    clearData({ commit }) {
        commit('CLEAR_DATA');
    },
    async getCostSummary({commit}, id){
        if(id <= 0) return;
        commit("SET_COST_SUMMARY", await axios.get(`api/costsummaries/${id}`))
    },
    async saveCostSummary({ commit, state}, id) {
        return await axios.post('api/costsummaries/', {
            orderId: id,
            transactionCost: state.costSummary.partnerTransactionCost,
            otherCost:  state.costSummary.partnerOtherCost,
        })         
    }
}
